import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppFacadeService } from '../../services/app-facade.service';
import { ComponentsToLoad } from '../../enums/components-to-load.enum';

@Component({
    selector: 'por-quote-conversion',
    templateUrl: './quote-conversion.component.html',
    styleUrls: ['./quote-conversion.component.scss'],
    standalone: false
})
export class QuoteConversionComponent {
    readonly appFacadeService = inject(AppFacadeService);

    onCloseClick() {
        this.appFacadeService.setActiveTab(ComponentsToLoad.Contracts);
    }
}
